import axiosInstance from "@/api/axiosInstance";
import { DeleteTranscriptRequest, DeleteTranscriptResponse } from "./types";

export const deleteTranscript = async (
  requestData: DeleteTranscriptRequest,
): Promise<DeleteTranscriptResponse> => {
  const response = await axiosInstance.delete<DeleteTranscriptResponse>(
    `/api/private/transcripts/${requestData.id}`,
  );

  return response.data;
};